<template>
    <ElButton @click="onButtonClick" :type="buttonType" :icon="buttonIcon" :size="buttonSize" :plain="plain" :circle="circle" :disabled="disabled">
        <slot>
            {{ buttonText }}
        </slot>
    </ElButton>
</template>

<script>
// import { MessageType } from 'element-plus/lib/components/message-box'
// import { componentSizes } from 'element-plus'

import { ElMessageBox } from 'element-plus';

const ButtonType = ['primary', 'success', 'warning', 'danger', 'info', 'text', '']
const MessageType = ['', 'success', 'warning', 'info', 'error']
const ComponentSize = ['', 'small', 'default', 'large']

export default {
    name: 'ConfirmButton',
    props: {
      buttonType: { type: String, default: 'primary', values: ButtonType },
      buttonSize: { type: String, default: '', values: ComponentSize },
      plain: { type: Boolean, default: false },
      circle: { type: Boolean, default: false },
      disabled: { type: Boolean, default: false },
      buttonIcon: { type: String, default: 'Check' },
      buttonText: { type: String, default: 'Submit' },
      submitText: { type: String, default: 'Confirm' },
      cancelText: { type: String, default: 'Cancel' },
      confirmationText: { type: String, default: 'Are you sure?' },
      title: { type: String, default: "Please confirm" },
      confirmationType: { type: String, default: 'warning', values: MessageType },
      prompt: { type: Boolean, default: false },
      inputPattern: { type: RegExp, default: undefined },
      inputErrorMessage: { type: String, default: undefined }
    },
    emits: ['confirm', 'cancel'],
    methods: {
        onButtonClick () {
            if (this.prompt) {
                this.openPrompt()
            } else {
                this.openConfirm()
            }
        },

        openConfirm () {
            ElMessageBox.confirm(
                this.confirmationText,
                this.title,
                {
                    confirmButtonText: this.submitText,
                    cancelButtonText: this.cancelText,
                    type: this.confirmationType
                }
            )
            .then(() => {
                this.$emit('confirm')
            })
            .catch(() => {
                this.$emit('cancel')
            })
        },

        openPrompt () {
            let options = {
                confirmButtonText: this.submitText,
                cancelButtonText: this.cancelText,
                inputPattern: this.inputPattern,
                inputErrorMessage: this.inputErrorMessage
            }

            ElMessageBox.prompt( this.confirmationText, this.title, options )
            .then( ({value}) => {
                this.$emit('confirm', value)
            })
            .catch(() => {
                this.$emit('cancel')
            })
        }
    }
}
</script>